
import DialogConfirm from './dialog-confirm.vue';

export default {
  name: 'landlord-settings',
  components: {
    DialogConfirm: DialogConfirm
  },
  props: {
    value: { type: Boolean, default: false },
    landlordId: { default: null },
    landlord: { type: Object, default: null },
    live: { type: Boolean, default: true }
  },
  data: function () {
    return {
      busy: false,
      pendingFile: null,
      pendingAvatar: null,
      pendingResidence: null,
      avatarBlob: '',
      residenceBlob: '',
      countryOpen: false,
      countryQuery: '',
      confirmResign: false,
      resignConfirmBody: '削除データの復元は不可能です\n本当に削除しますか？',
      form: this.emptyForm()
    };
  },
  computed: {
    opened: function () {
      return this.value;
    },
    isCreate: function () {
      return !this.form.id;
    },
    isCorp: function () {
      return !!(this.form.account_type && this.form.account_type !== 'owner');
    },
    loginIdText: function () {
      return this.form.username || this.form.email || '';
    },
    identityType: {
      get: function () {
        return this.isCorp ? '企業' : (this.form.gender || '男');
      },
      set: function (value) {
        if (value === '企業') {
          this.form.account_type = 'corporation';
          if (!(this.form.contactName || '').trim()) {
            this.form.contactName = this.joinPerson(this.form.lastname, this.form.firstname);
          }
          return;
        }
        if (this.form.account_type && this.form.account_type !== 'owner') {
          var person = this.splitPerson(this.form.contactName);
          if (person.last || person.first) {
            this.form.lastname = person.last;
            this.form.firstname = person.first;
          }
        }
        this.form.account_type = 'owner';
        this.form.gender = value;
      }
    },
    avatarStyle: function () {
      var src = this.avatarBlob || (this.form.avatar_url ? this.url(this.form.avatar_url) : '');
      if (!src) return {};
      return { backgroundImage: 'url("' + src + '")' };
    },
    residenceStyle: function () {
      var src = this.residenceBlob || (this.form.residence_card_url ? this.url(this.form.residence_card_url) : '');
      if (!src) return {};
      return { backgroundImage: 'url("' + src + '")' };
    },
    accountTypeLabel: function () {
      if (!this.form.account_type || this.form.account_type === 'owner') return 'オーナー';
      return '企業';
    },
    hasContract: function () {
      return !!(this.pendingFile || this.form.contract_pdf_url);
    },
    countryFlag: function () {
      var code = this.countryCode(this.form.nationality);
      return code ? this.flagSrc(code) : '';
    },
    filteredCountries: function () {
      var list = window.COUNTRY_LIST || [];
      var q = (this.countryQuery || '').trim().toLowerCase();
      var out = [];
      var i;
      for (i = 0; i < list.length; i++) {
        var c = list[i];
        var text = String(c.text || '').toLowerCase();
        var code = String(c.code || '').toLowerCase();
        if (!q || text.indexOf(q) > -1 || code.indexOf(q) > -1) out.push(c);
        if (out.length >= 40) break;
      }
      return out;
    }
  },
  watch: {
    value: function (opened) {
      if (opened) this.bootstrap();
    }
  },
  beforeDestroy: function () {
    this.revokeBlobs();
  },
  methods: {
    emptyForm: function () {
      return {
        id: null,
        account_no: '',
        username: '',
        password: '',
        lastname: '',
        firstname: '',
        registered_at: '',
        contract_start: '',
        account_type: 'owner',
        contract_years: '',
        contract_pdf_url: '',
        note: '',
        avatar_url: '',
        residence_card_url: '',
        bank_name: '',
        bank_branch: '',
        bank_account_no: '',
        bank_account_name: '',
        invoice_reg_no: '',
        gender: '男',
        nationality: '',
        companyPrefix: '',
        companyName: '',
        representative: '',
        contactName: '',
        phone: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        email: '',
        post1: '',
        post2: '',
        address: ''
      };
    },
    toast: function (msg) {
      if (window.A && A.toast) A.toast(msg);
    },
    toastMock: function () {
      this.toast('mock：未接线');
    },
    toastFail: function (status) {
      if (status == -5) this.toast('未ログイン');
      else if (status == -6) this.toast('権限がありません');
      else if (status == 2) this.toast('メールまたはログインIDが既に使われています');
      else this.toast('失敗しました');
    },
    formatDotDate: function (val) {
      if (!val) return '';
      return String(val).replace(/-/g, '.').slice(0, 10);
    },
    toDateInput: function (val) {
      if (!val) return '';
      return String(val).replace(/\./g, '-').slice(0, 10);
    },
    emptyToNull: function (val) {
      if (val === '' || val === null || val === undefined) return null;
      return val;
    },
    nameWidth: function (val, placeholder) {
      var text = val || placeholder || '';
      return (text.length + 0.4) + 'em';
    },
    flagSrc: function (code) {
      return '/assets/img/flag/' + code + '.svg';
    },
    countryCode: function (val) {
      var raw = String(val || '').trim();
      if (!raw) return '';
      var list = window.COUNTRY_LIST || [];
      var lower = raw.toLowerCase();
      var i;
      for (i = 0; i < list.length; i++) {
        var c = list[i];
        if (String(c.code).toLowerCase() === lower) return c.code;
        if (String(c.passport || '').toLowerCase() === lower) return c.code;
        if (c.text === raw) return c.code;
      }
      return /^[a-z]{2}$/.test(lower) ? lower : '';
    },
    close: function () {
      this.countryOpen = false;
      this.$emit('input', false);
    },
    onSheetClick: function (e) {
      if (!e.target.closest || !e.target.closest('.ols-nation')) this.countryOpen = false;
    },
    revokeBlobs: function () {
      if (this.avatarBlob) URL.revokeObjectURL(this.avatarBlob);
      if (this.residenceBlob) URL.revokeObjectURL(this.residenceBlob);
      this.avatarBlob = '';
      this.residenceBlob = '';
    },
    clearPending: function () {
      this.pendingFile = null;
      this.pendingAvatar = null;
      this.pendingResidence = null;
      this.countryOpen = false;
      this.countryQuery = '';
      this.revokeBlobs();
    },
    bootstrap: function () {
      this.busy = false;
      this.confirmResign = false;
      this.clearPending();
      var id = this.landlordId;
      if (!id && this.landlord && this.landlord.id) id = this.landlord.id;
      if (this.landlord) this.fill(this.landlord);
      else this.form = this.emptyForm();
      if (id && this.live) this.loadDetail(id);
      else if (!this.landlord) this.form = this.emptyForm();
    },
    loadDetail: function (id) {
      var t = this;
      axios.get('landlord/' + id).then(function (res) {
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        var item = res.data.options && res.data.options.item;
        if (item) t.fill(item);
      }).catch(function () {
        t.toast('通信に失敗しました');
      });
    },
    fill: function (item) {
      var f = this.emptyForm();
      f.id = item.id || null;
      f.account_no = item.account_no || '';
      f.username = item.username || '';
      f.lastname = item.lastname || '';
      f.firstname = item.firstname || '';
      f.registered_at = item.registered_at || '';
      f.contract_start = this.toDateInput(item.contract_start);
      f.account_type = item.account_type || 'owner';
      f.contract_years = item.contract_years == null ? '' : item.contract_years;
      f.contract_pdf_url = item.contract_pdf_url || '';
      f.note = item.note || '';
      f.avatar_url = item.avatar_url || '';
      f.residence_card_url = item.residence_card_url || '';
      f.bank_name = item.bank_name || '';
      f.bank_branch = item.bank_branch || '';
      f.bank_account_no = item.bank_account_no || '';
      f.bank_account_name = item.bank_account_name || '';
      f.invoice_reg_no = item.invoice_reg_no || '';
      f.gender = item.gender || '男';
      f.nationality = item.nationality || '';
      var company = this.splitCompany(item.company_name);
      f.companyPrefix = company.prefix;
      f.companyName = company.name;
      f.representative = item.representative || '';
      f.contactName = this.joinPerson(item.lastname, item.firstname);
      f.phone = item.phone || '';
      f.email = item.email || '';
      f.address = item.address || '';
      var b = String(item.birthday || '').replace(/\./g, '-').split('-');
      f.birthYear = b[0] || '';
      f.birthMonth = b[1] || '';
      f.birthDay = b[2] || '';
      var post = String(item.postcode || '').replace(/[^0-9]/g, '');
      f.post1 = post.slice(0, 3);
      f.post2 = post.slice(3, 7);
      this.form = f;
    },
    joinPerson: function (last, first) {
      last = String(last || '').trim();
      first = String(first || '').trim();
      if (last && first) return last + '　' + first;
      return last || first;
    },
    splitPerson: function (value) {
      var parts = String(value || '').trim().split(/[\s　]+/).filter(Boolean);
      return {
        last: parts[0] || '',
        first: parts.slice(1).join('　')
      };
    },
    splitCompany: function (value) {
      var parts = String(value || '').trim().split(/[\s　]+/).filter(Boolean);
      if (parts.length <= 1) return { prefix: '', name: parts[0] || '' };
      return { prefix: parts[0], name: parts.slice(1).join('　') };
    },
    joinCompany: function () {
      var prefix = (this.form.companyPrefix || '').trim();
      var name = (this.form.companyName || '').trim();
      if (prefix && name) return prefix + '　' + name;
      return prefix || name;
    },
    joinBirthday: function () {
      var y = (this.form.birthYear || '').trim();
      var m = (this.form.birthMonth || '').trim();
      var d = (this.form.birthDay || '').trim();
      if (!y && !m && !d) return '';
      if (m.length === 1) m = '0' + m;
      if (d.length === 1) d = '0' + d;
      return y + '-' + m + '-' + d;
    },
    joinPost: function () {
      return String(this.form.post1 || '') + String(this.form.post2 || '');
    },
    pickAvatar: function () {
      if (this.$refs.avatarFile) this.$refs.avatarFile.click();
    },
    pickResidence: function () {
      if (this.$refs.residenceFile) this.$refs.residenceFile.click();
    },
    takeImage: function (e, kind) {
      var files = e.target.files;
      var file = files && files[0] ? files[0] : null;
      e.target.value = '';
      if (!file) return;
      var blob = URL.createObjectURL(file);
      if (kind === 'avatar') {
        if (this.avatarBlob) URL.revokeObjectURL(this.avatarBlob);
        this.pendingAvatar = file;
        this.avatarBlob = blob;
      } else {
        if (this.residenceBlob) URL.revokeObjectURL(this.residenceBlob);
        this.pendingResidence = file;
        this.residenceBlob = blob;
      }
    },
    onAvatarFile: function (e) {
      this.takeImage(e, 'avatar');
    },
    onResidenceFile: function (e) {
      this.takeImage(e, 'residence');
    },
    onUploadClick: function () {
      if (this.$refs.contractFile) this.$refs.contractFile.click();
    },
    onContractFile: function (e) {
      var files = e.target.files;
      this.pendingFile = files && files[0] ? files[0] : null;
      e.target.value = '';
    },
    openContract: function () {
      if (this.pendingFile) {
        window.open(URL.createObjectURL(this.pendingFile));
        return;
      }
      if (this.form.contract_pdf_url) window.open(this.url(this.form.contract_pdf_url));
    },
    selectCountry: function (c) {
      this.form.nationality = c.code;
      this.countryOpen = false;
      this.countryQuery = '';
    },
    buildPayload: function () {
      var username = (this.form.username || '').trim();
      var email = (this.form.email || '').trim();
      if (this.isCreate && !username && email) username = email;
      if (this.isCreate && !email && username.indexOf('@') > -1) email = username;
      var lastname = this.form.lastname;
      var firstname = this.form.firstname;
      if (this.isCorp) {
        var person = this.splitPerson(this.form.contactName);
        lastname = person.last;
        firstname = person.first;
      }
      var payload = {
        email: email,
        lastname: lastname,
        firstname: firstname,
        company_name: this.joinCompany(),
        representative: this.form.representative,
        contract_start: this.emptyToNull(this.toDateInput(this.form.contract_start)),
        contract_years: this.emptyToNull(this.form.contract_years),
        note: this.form.note,
        bank_name: this.form.bank_name,
        bank_branch: this.form.bank_branch,
        bank_account_no: this.form.bank_account_no,
        bank_account_name: this.form.bank_account_name,
        invoice_reg_no: this.form.invoice_reg_no,
        gender: this.form.gender,
        nationality: this.form.nationality,
        account_type: this.form.account_type,
        phone: this.form.phone,
        birthday: this.joinBirthday(),
        address: this.form.address,
        postcode: this.joinPost()
      };
      if (this.form.id) {
        payload.id = this.form.id;
      } else {
        payload.username = username;
        payload.password = this.form.password;
      }
      return payload;
    },
    onSave: function () {
      if (!this.live) {
        this.close();
        this.toastMock();
        return;
      }
      if (this.busy) return;
      if (this.isCreate) {
        if (this.isCorp) {
          if (!this.joinCompany()) {
            this.toast('会社名を入力してください');
            return;
          }
        } else if (!(this.form.lastname || '').trim() || !(this.form.firstname || '').trim()) {
          this.toast('姓名を入力してください');
          return;
        }
        if (!(this.form.username || '').trim() && !(this.form.email || '').trim()) {
          this.toast('ログインIDまたはEmailを入力してください');
          return;
        }
        if (!(this.form.password || '').trim()) {
          this.toast('パスワードを入力してください');
          return;
        }
      }
      var t = this;
      t.busy = true;
      axios.post('landlord/save', this.buildPayload()).then(function (res) {
        if (res.data.status != 1) {
          t.busy = false;
          t.toastFail(res.data.status);
          return;
        }
        var item = res.data.options && res.data.options.item;
        if (item && item.id) t.form.id = item.id;
        t.uploadThenFinish(item);
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    },
    uploadThenFinish: function (item) {
      var t = this;
      var id = (item && item.id) || t.form.id;
      var jobs = [];
      if (t.pendingAvatar) jobs.push({ file: t.pendingAvatar, path: 'landlord/uploadAvatar' });
      if (t.pendingResidence) jobs.push({ file: t.pendingResidence, path: 'landlord/uploadResidenceCard' });
      if (t.pendingFile) jobs.push({ file: t.pendingFile, path: 'landlord/uploadContract' });
      if (!jobs.length || !id) {
        t.busy = false;
        t.close();
        t.$emit('saved', item);
        return;
      }
      var last = item;
      var index = 0;
      var next = function () {
        if (index >= jobs.length) {
          t.busy = false;
          t.pendingAvatar = null;
          t.pendingResidence = null;
          t.pendingFile = null;
          t.close();
          t.$emit('saved', last);
          return;
        }
        var job = jobs[index++];
        var fd = new FormData();
        fd.append('image', job.file);
        fd.append('landlord_id', id);
        axios.post(job.path, fd, {
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function (res) {
          if (res.data.status != 1) t.toastFail(res.data.status);
          else if (res.data.options && res.data.options.item) last = res.data.options.item;
          next();
        }).catch(function () {
          t.toast('アップロードに失敗しました');
          next();
        });
      };
      next();
    },
    onCancel: function () {
      this.close();
    },
    onResign: function () {
      if (!this.live) {
        this.close();
        this.toastMock();
        return;
      }
      if (!this.form.id || this.busy) return;
      this.confirmResign = true;
    },
    onResignOk: function () {
      if (!this.form.id || this.busy) return;
      var t = this;
      t.busy = true;
      axios.post('landlord/resign/' + this.form.id).then(function (res) {
        t.busy = false;
        if (res.data.status != 1) {
          t.toastFail(res.data.status);
          return;
        }
        t.close();
        t.$emit('resigned', res.data.options && res.data.options.item);
      }).catch(function () {
        t.busy = false;
        t.toast('通信に失敗しました');
      });
    }
  }
};
